export function getQueryParams() {
    const queryParams = {};
    const query = window.location.search.substring(1);
    const queryParts = query.split('&');

    for (let i = 0; i < queryParts.length; i++) {
        const keyValue = queryParts[i].split('=');
        const key = keyValue[0];
        const value = keyValue[1];
        const currentValue = queryParams[key];

        if (Array.isArray(currentValue)) {
            currentValue.push(decodeURIComponent(value));
        } else if (currentValue != null) {
            queryParams[key] = [currentValue, decodeURIComponent(value)];
        } else {
            queryParams[key] = decodeURIComponent(value);
        }
    }

    return queryParams;
}

export function getOuterHeight(element) {
    const height = element.offsetHeight;
    const style = getComputedStyle(element);
    const marginTop = parseInt(style.marginTop);
    const marginBottom = parseInt(style.marginBottom);
    return height + marginTop + marginBottom;
}
